import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container"];
  static values = {
    organizationId: String,
  };

  connect() {
    console.log(
      "Attachments controller connected - v3 - " + new Date().toISOString()
    );
    console.log("Organization ID Value:", this.organizationIdValue);
    console.log("Element:", this.element);
  }

  // Handle setting attachment as logo
  async setAsLogo(event) {
    event.preventDefault();
    const attachmentId = event.currentTarget.dataset.attachmentId;

    if (!attachmentId) {
      console.error("No attachment ID found");
      return;
    }

    console.log("Organization ID Value:", this.organizationIdValue);
    console.log("Attachment ID:", attachmentId);
    const url = `/organizations/${this.organizationIdValue}/update-logo/${attachmentId}`;
    console.log("Requesting URL:", url);

    try {
      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
            ?.content,
          Accept: "application/json",
        },
        credentials: "same-origin",
      });

      if (response.ok) {
        try {
          const responseText = await response.text();
          console.log("Response text:", responseText);

          let data;
          try {
            data = JSON.parse(responseText);
          } catch (parseError) {
            console.error("JSON parse error:", parseError);
            console.error("Response text was:", responseText);
            throw new Error("Server returned invalid JSON");
          }

          if (data.success) {
            this.showSuccessMessage(
              data.message || "Logo updated successfully"
            );
            // Optionally refresh the page to show the new logo
            setTimeout(() => window.location.reload(), 1500);
          } else {
            throw new Error(data.message || "Failed to update logo");
          }
        } catch (jsonError) {
          console.error("JSON parsing error:", jsonError);
          throw new Error("Invalid response from server");
        }
      } else {
        throw new Error(`Failed to update logo: ${response.status}`);
      }
    } catch (error) {
      console.error("Logo update error:", error);
      this.showErrorMessage(`Failed to update logo: ${error.message}`);
    }
  }

  // Handle setting attachment as cover
  async setAsCover(event) {
    event.preventDefault();
    const attachmentId = event.currentTarget.dataset.attachmentId;

    if (!attachmentId) {
      console.error("No attachment ID found");
      return;
    }

    console.log("Organization ID Value:", this.organizationIdValue);
    console.log("Attachment ID:", attachmentId);
    const url = `/organizations/${this.organizationIdValue}/update-cover/${attachmentId}`;
    console.log("Requesting URL:", url);

    try {
      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
            ?.content,
          Accept: "application/json",
        },
        credentials: "same-origin",
      });

      if (response.ok) {
        try {
          const responseText = await response.text();
          console.log("Response text:", responseText);

          let data;
          try {
            data = JSON.parse(responseText);
          } catch (parseError) {
            console.error("JSON parse error:", parseError);
            console.error("Response text was:", responseText);
            throw new Error("Server returned invalid JSON");
          }

          if (data.success) {
            this.showSuccessMessage(
              data.message || "Cover updated successfully"
            );
            // Optionally refresh the page to show the new cover
            setTimeout(() => window.location.reload(), 1500);
          } else {
            throw new Error(data.message || "Failed to update cover");
          }
        } catch (jsonError) {
          console.error("JSON parsing error:", jsonError);
          throw new Error("Invalid response from server");
        }
      } else {
        throw new Error(`Failed to update cover: ${response.status}`);
      }
    } catch (error) {
      console.error("Cover update error:", error);
      this.showErrorMessage(`Failed to update cover: ${error.message}`);
    }
  }

  // Handle removal with confirmation
  remove(event) {
    event.preventDefault();
    const fileName = event.currentTarget.dataset.fileName;
    const attachmentId = event.currentTarget.dataset.attachmentId;

    if (
      confirm(
        `You're about to permanently remove ${fileName}. This cannot be undone.`
      )
    ) {
      this.performRemoval(attachmentId, event.currentTarget);
    }
  }

  async performRemoval(attachmentId, button) {
    try {
      const response = await fetch(`/attachments/${attachmentId}`, {
        method: "DELETE",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
            ?.content,
          Accept: "application/json",
        },
      });

      if (response.ok) {
        // Remove the attachment element from the DOM
        const attachmentElement = button.closest("[data-attachment-id]");
        if (attachmentElement) {
          attachmentElement.remove();
        }
        this.showSuccessMessage("Attachment removed successfully");
      } else {
        throw new Error(`Failed to remove attachment: ${response.status}`);
      }
    } catch (error) {
      console.error("Error removing attachment:", error);
      this.showErrorMessage(`Failed to remove attachment: ${error.message}`);
    }
  }

  showSuccessMessage(message) {
    // Simple success feedback
    console.log("Success:", message);
    // You could also show a toast notification here if you have a toast system
  }

  showErrorMessage(message) {
    // Simple error feedback
    console.error(message);
    alert(message);
  }
}
